import React, { useState, useEffect } from "react";
import ApiService from "../../../Services/user/service";
import { set } from "date-fns";
import { ArrowDownCircle, ArrowUpCircle, Wallet2 } from "lucide-react";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
const BalanceStatement = () => {
  const user_id = localStorage.getItem("user_id");
  const currency = localStorage.getItem("currentCurrency") ?? "1"; // <-- Currency Read
  const [balanceData, setBalanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const[totalPages, setTotalPages] = useState(1);
  const[totalRecords, setTotalRecords] = useState(0);
  const[perPage, setPerPage] = useState(10);
  const[page, setPage] = useState(1);
  // ----------- 💰 INR DATA ------------
  const getBalanceStatementInr = async () => {
    try {

  const data = {
    userid: user_id,
       page: page, 
       limit: perPage
       
  }
      setLoading(true);
      const res = await ApiService.balanceStatementInr(data);
      setBalanceData(res?.data?.data || []);
      setTotalPages(res?.data?.totalPages);
      setTotalRecords(res?.data?.totalRecords);
    
    } catch {
      setBalanceData([]);
    } finally {
      setLoading(false);
    }
  };


  const totalDeposit = balanceData
  .filter((i) => i.type === "CREDIT")
  .reduce((sum, item) => sum + Number(item.Amount || 0), 0);

const totalWithdrawal = balanceData
  .filter((i) => i.type === "DEBIT")
  .reduce((sum, item) => sum + Math.abs(Number(item.Amount || 0)), 0);

const totalBalance = totalDeposit - totalWithdrawal;

  // ----------- 💵 USD DATA ------------
  const getBalanceStatementUsd = async () => {
    try {
        const data = {
    userid: user_id,
       page: page, 
       limit: perPage
  }
      setLoading(true);
      const res = await ApiService.balanceStatement(data);
      setBalanceData(res?.data?.data || []);
        setTotalPages(res?.data?.totalPages);
      setTotalRecords(res?.data?.totalRecords);
    } catch {
      setBalanceData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {


    if (currency === "1") getBalanceStatementInr();  
    else getBalanceStatementUsd();                  

  }, [currency, user_id , page, perPage]);

  // --------------------------------------

  const rows = [...balanceData].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const formatDate = (d) => d ? new Date(d).toLocaleString() : "--";


    const onPageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

 const handlePerPageChange = (e) => {
  setPerPage(Number(e.target.value));
  setPage(1); 
};


  return (
    <div className="container-fluid">
      <div className="card shadow-sm border-0">

        <div className="card-header flex-column align-items-start">
         
          <h4 className="card-title mb-1">
        <Wallet2 size={28} /> Balance Statement 
          </h4>
          <small className="text-muted">Wallet Transaction History</small>
        </div>
<div className="d-flex flex-row flex-wrap justify-content-between px-3 pt-3 gap-2">

  {/* Deposit */}
  <div className="d-flex flex-row align-items-center gap-2 flex-fill p-2 rounded shadow-sm border" style={{ background: "#fff", minWidth: "100px" }}>
    <div className="text-success d-flex align-items-center">
      <ArrowDownCircle size={18} />
    </div>
    <div>
      <div className="text-muted" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>Total Deposit</div>
      <div className="fw-bold text-success" style={{ fontSize: "13px" }}>
        {currency === "1" ? "₹" : "$"} {totalDeposit.toFixed(2)}
      </div>
    </div>
  </div>

  {/* Withdrawal */}
  <div className="d-flex flex-row align-items-center gap-2 flex-fill p-2 rounded shadow-sm border" style={{ background: "#fff", minWidth: "100px" }}>
    <div className="text-danger d-flex align-items-center">
      <ArrowUpCircle size={18} />
    </div>
    <div>
      <div className="text-muted" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>Total Withdrawal</div>
      <div className="fw-bold text-danger" style={{ fontSize: "13px" }}>
        {currency === "1" ? "₹" : "$"} {totalWithdrawal.toFixed(2)}
      </div>
    </div>
  </div>

  {/* Balance */}
  <div className="d-flex flex-row align-items-center gap-2 flex-fill p-2 rounded shadow-sm border" style={{ background: "#fff", minWidth: "100px" }}>
    <div className="text-primary d-flex align-items-center">
      <Wallet2 size={18} />
    </div>
    <div>
      <div className="text-muted" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>Total Balance</div>
      <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
        {currency === "1" ? "₹" : "$"} {totalBalance.toFixed(2)}
      </div>
    </div>
  </div>

</div>



        <div className="card-body">

          {loading && <p className="text-center text-muted">Loading...</p>}

          {!loading && rows.length === 0 && (
            <p className="text-center text-muted py-2">No Balance Records Found</p>
          )}

          {!loading && rows.length > 0 && (
            <div className="balance-list">
              {rows.map((row, index) => {
                const credit = row.type === "CREDIT";
                const amt = Number(row.Amount) || 0;

                return (
                  <div key={index} className="balance-item shadow-sm mb-3 statement-card">
                    <div className="d-flex justify-content-between ">

                      {/* LEFT */}
                      <div>
                        <div className="fw-semibold">{row.message}</div>
                        <div className="text-muted small">{fDateTimesec(row.createdAt)}</div>

                       
                      </div>

                      {/* RIGHT */}
                      <div className="text-end">
                         <span className={`badge rounded-pill my-1 ${credit ? "bg-success-light text-success" : "bg-danger-light text-danger"}`}>
                          {row.type}
                        </span>
                        <div className={`fw-bold ${credit ? "text-success" : "text-danger"}`}>
                          {credit ? `+ ${currency==="1"?"₹":"$"}${amt}` : `- ${currency==="1"?"₹":"$"}${amt}`}
                        </div>
                        {/* <div className="small text-muted">
                          Balance: {row.after_balance ? `${currency==="1"?"₹":"$"}${row.after_balance}` : "--"}
                        </div> */}
                      </div>

                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>

      <style>
        {`
          .balance-item{background:#fff;border:1px solid #eee;padding:12px;border-radius:8px;}
          
        `}
      </style>
       <div className="pagination d-flex bg-light justify-content-between align-items-center py-3 px-3">

  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-2">
    <label className="mb-0">Rows per page:</label>
    <select
      className="form-select form-select-sm"
      style={{ width: 90 }}
      value={perPage}
      onChange={handlePerPageChange}
    >
      {[5, 10, 20, 50, 100].map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </select>
    <small className="ms-2 text-muted">
      {totalRecords} records
    </small>
  </div>

  {/* RIGHT SIDE */}
  <div className="d-flex align-items-center">
    <button
      className="btn btn-outline-primary"
      disabled={page === 1}
      onClick={() => onPageChange(page - 1)}
    >
      ◀ Prev
    </button>

    <span className="mx-3">Page {page} of {totalPages || 1}</span>

    <button
      className="btn btn-outline-primary"
      disabled={page === totalPages || totalPages === 0}
      onClick={() => onPageChange(page + 1)}
    >
      Next ▶
    </button>
  </div>

</div>
    </div>
  );
};

export default BalanceStatement;
